<template>

  <div class="container" id="app">

    <div class="backgroundWhite" v-bind:style="{ transform: 'rotate(' + this.angle +'deg)', left: this.position + 'vw' }"></div>


    <div class="badge" id="badgeRot">
      <transition name="slide-fade" mode="out-in">
          <Badges :key="badgeRot"  class="badgeRot" v-bind:fooBadge="badgeRot"></Badges>
      </transition>
    </div>

    <div class="ergebniss">
      <Torzaehler id="torRot"class="tore" v-bind:tore="toreRot"></Torzaehler>
      <div class="doppelPunkt"><h1>-</h1></div>
      <Torzaehler id="torBlau" class="tore" v-bind:tore="toreBlau"></Torzaehler>
    </div>

    <div class="badge" id="badgeBlau">
      <transition name="slide-fade" mode="out-in">
          <Badges :key="badgeBlau"  class="badgeRot" v-bind:fooBadge="badgeBlau"></Badges>
      </transition>
    </div>

    <div id="kommentar">
      <p id="kommentarText">"{{message}}"</p>
    </div>

  </div>

</template>
<script>
import Torzaehler from './components/Torzaehler'
import Badges from './components/Badges'

export default {
  name: 'app',
  components: {
    Torzaehler,
    Badges
  },
  data () {
    return {
      source: "",

      badgeRotDate:"-",
      badgeRot:"-",

      badgeBlauDate:"-",
      badgeBlau: "-",

      toreRotDate: "-",
      toreRot: "-",

      toreRotBlau: "-",
      toreBlau: "-",

      messageDate: "-",
      message: "0",
      messages: [ "Aua, aua, aua", "Cüz Lan, Süßkram", "Bedauerlich", "Ärgerlich", "Nicht erstrebenswert", "Jetzt fühlt er sich wie Magic Max", "Goaaaaaaaaal", "Schwierig", "Sweet", "Oh nein, oh nein, oh nein", "Hauptsache es geht Alessio gut"  ],


      showRot: false,




    }
  },

  computed: {
    angle(){
      return (this.toreRot - this.toreBlau) * 2
    },
    position(){
       return -150 + (this.toreRot - this.toreBlau)
    }

  },
  timers: {
    loadLog: { time: 100, autostart: true, repeat:false },
    loadData: { time: 1000, autostart: true, repeat:true }
  },
  methods: {

    loadLog(){
      this.$http.get("https://io.adafruit.com/api/v2/dennha/feeds?X-AIO-Key=efa72a278ef640e3bc1454efaaedc8c2").then(function(data){
        console.log(data)
      });
    },
    loadData() {
      this.$http.get("https://io.adafruit.com/api/v2/dennha/feeds?X-AIO-Key=efa72a278ef640e3bc1454efaaedc8c2").then(function(data){

        //toreRot
        var currentEventTR = new String(this.toreRotDate)
        var currentEventUpdateTR = new String(data.body[0].updated_at)
        if (currentEventTR.valueOf() !== currentEventUpdateTR.valueOf()){
          this.toreRot = data.body[0].last_value
          this.toreRotDate = data.body[0].updated_at
        }
        //toreBlau
        var currentEventTB = new String(this.toreBlauDate)
        var currentEventUpdateTB = new String(data.body[1].updated_at)
        if (currentEventTB.valueOf() !== currentEventUpdateTB.valueOf()){
          this.toreBlau = data.body[1].last_value
          this.toreBlauDate = data.body[1].updated_at
        }

        //badgeRot
        var currentEventBR = new String(this.badgeRotDate)
        var currentEventUpdateBR = new String(data.body[2].updated_at)
        if (currentEventBR.valueOf() !== currentEventUpdateBR.valueOf()){
            this.showRot = !this.showRot
            this.badgeRot = data.body[2].last_value
            this.badgeRotDate = data.body[2].updated_at

        }

        //badgeBlau
        var currentEventBB = new String(this.badgeBlauDate)
        var currentEventUpdateBB = new String(data.body[3].updated_at)
        if (currentEventBB.valueOf() !== currentEventUpdateBB.valueOf()){
            this.badgeBlau = data.body[3].last_value
            this.badgeBlauDate = data.body[3].updated_at
        }

        //message
        var currentEventTM = new String(this.messageDate)
        var currentEventUpdateTM = new String(data.body[4].updated_at)
        if (currentEventTM.valueOf() !== currentEventUpdateTM.valueOf()){
          var rndNmr = data.body[4].last_value
          this.message = this.messages[rndNmr]
          this.messageDate = data.body[4].updated_at
        }
      });
    }
  }
}

</script>
<style>
body{
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  background-color: #000;
}
  .container{
    min-width: 100vw;
    padding:0;

    color: #fff;
  }
  #app {
    height: 100vh;
    display: grid; /* display: inline-grid;*/
    grid-template-columns: 2fr 5fr 2fr;
  }
  .ergebniss{
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .badge{

    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    align-items: center;

    max-height: 100vh;
    overflow: hidden;
  }

  .badgeImg{
    max-width: 95%;
  }
  #torRot{
    mix-blend-mode: difference;
  }
  #torBlau{
    mix-blend-mode: difference;
  }

  #badgeWrapperRot{
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 2;
  }

  #badgeWrapperBlau{
    grid-column-start: 3;
    grid-column-end: 4;
    grid-row-start: 1;
    grid-row-end: 2;
  }
  #kommentar{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 3vw;
    grid-column-start: 2;
    grid-column-end: 3;
    grid-row-start: 2;
    grid-row-end: 2;
    color: #000;
  }
  #kommentarText{
      background: rgb(255, 255, 255);
      /* mix-blend-mode: difference; */
        padding: 2vh 2vw;
        min-width: 10vw;

  }
  .smallImg{
    width: 50%;
  }
  .doppelPunkt{
    font-size: 10vw;
    top: 150px;
    mix-blend-mode: difference;
  }

  .slide-fade-enter-active {
    transition: all .6s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s ease;
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    /* transform: translateY(40px); */
    opacity: 0;
  }

  .backgroundWhite{

    /* transform: rotate(33deg); */
    position: absolute;
    top: -100vh;
    width: 200vw;
    height: 500vh;
    z-index: -2;
    background: #fff;
    /* transition-property: transform;
    transition-duration: 0.5s; */
  }

</style>



// WEBPACK FOOTER //
// src/App.vue